// Advisor online-first triage (UI mirror).
//
// Canonical source of truth is lib/advisor/triage.js — keep the two in sync.
// See that file for the full rationale. In short: decide the DEFAULT framing of
// the "try online now vs. book the appointment" choice from the captured request:
//   - 'online-first'  → self-serviceable request; lead with "Try online now".
//   - 'advisor-first' → advisor-only topic (estate/complex tax/trade/margin/options)
//                       or no request context; lead with "Book the appointment".

const ADVISOR_ONLY_SIGNALS = [
  /estate/i,
  /\bwill\b/i,
  /probate/i,
  /inheritance/i,
  /\btrust\b/i,
  /power of attorney/i,
  /succession/i,
  /complex tax|tax planning|tax strategy/i,
  /trade execution|execute (a |the )?trade|place (a |an )?(trade|order)/i,
  /\bmargin\b/i,
  /\boptions?\b/i,
  /derivatives?/i,
];

const SELF_SERVICE_SIGNALS = [
  /balance/i,
  /budget/i,
  /spend(ing)?/i,
  /transfer/i,
  /pay ?down|pay off/i,
  /move (money )?to savings|move to savings/i,
  /how much/i,
  /reward/i,
  /statement/i,
  /transaction/i,
  /interac|e-?transfer|email money transfer/i,
  /save|saving/i,
];

export function classifyTriage(text) {
  const t = typeof text === 'string' ? text.trim() : '';
  if (!t) return { mode: 'advisor-first', reason: 'no-request-context' };
  for (const re of ADVISOR_ONLY_SIGNALS) {
    if (re.test(t)) return { mode: 'advisor-first', reason: 'advisor-only-topic' };
  }
  for (const re of SELF_SERVICE_SIGNALS) {
    if (re.test(t)) return { mode: 'online-first', reason: 'self-serviceable' };
  }
  return { mode: 'online-first', reason: 'default-online-first' };
}
